import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, LoadingController, ToastController } from 'ionic-angular';

import { PaymentMethodHandler } from '../../providers/payment-method-handler';
import { ConsumerMoneyProvider } from '../../providers/consumer-money-handler';
import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';
import { ConsumerPrepayAmountManagerHandler } from '../../providers/consumer-prepay-amount-handler';

import { PaymentMethodListPage } from '../../pages/payment-method-list/payment-method-list';

import { BaseManagement } from '../../providers/base-management';


@Component({
  selector: 'page-consumer-add-money',
  templateUrl: 'consumer-add-money.html',
})
export class ConsumerAddMoneyPage extends BaseManagement {
	amountToAdd: any = 0;
	business: any;
	amountsToAdd: any = [];
  	paymentMethodId: any;

  	params: {
  		cb: any,
  		businessId: any
  	}

	constructor(
		public toastCtrl: ToastController,
	    public actionSheetCtrl: ActionSheetController,
	    public loadingCtrl: LoadingController,		
		public navCtrl: NavController, 
		public navParams: NavParams,
		public paymentMethodHandler: PaymentMethodHandler,
		public consumerMoneyProvider: ConsumerMoneyProvider,	
		public prepayAmountHandler: ConsumerPrepayAmountManagerHandler,	
		public businessProvider: ConsumerBusinessHandlerProvider,		
	) {
		super();

		this.business = this.navParams.get('business')

	    let method = this.paymentMethodHandler.getDefaultMethod();

	    this.paymentMethodId = method.id	
			
		if(this.business)
			this.loadAmountsToAdd(this.business.Id)
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerAddMoneyPage');
	}

	loadAmountsToAdd(businessId) {

		this.params = {
			cb: (amountsToAdd)=>{
				this.amountsToAdd = amountsToAdd;
			},
			businessId: businessId
		}
		
		this.prepayAmountHandler.getPrepayAmounts(this.params)
	}

	addMethod(){
		this.navCtrl.push(PaymentMethodListPage);    
	}

	tryBuyMoney(){
		let actionSheet = this.actionSheetCtrl.create({
			title: '$' + this.amountToAdd + ' will be charged from your card. Are you sure? This is non-refundable.',
			buttons: [
			{
			   text: 'Yes',
			   handler: () => {
			       console.log('Archive clicked');

			       this.buyMoney()

			       actionSheet.dismiss();

			       return false;
			   }
			},
			{
			   text: 'No',
			   handler: () => {
			     actionSheet.dismiss();

			     return false;
			   }
			}]
		});

		actionSheet.present();  
	}

	buyMoney(){
		var loader = this.loadingCtrl.create({
			content: "Adding money...",
			showBackdrop: true
		});

		loader.present();  

		var method = this.paymentMethodHandler.getMethodById(this.paymentMethodId);

		var data = {
			Quantity: 1,
			ProductTypeId: 6,
			Expiration: method.expiry,
			CVC: method.cvc,
			CardNumber: method.number,
			TotalAmount: this.amountToAdd
		};

		this.consumerMoneyProvider.purchaseCredit({
		    payment: data,    	
		    business: this.business
		})
		.then((data: any)=>{
			loader.dismiss();

			if(data.Message){
				let toast = this.toastCtrl.create({
					message: 'There was an error: ' + data.Message,
					duration: 5000,
					position: 'bottom'
				});

				toast.present();  
			}else{
				let toast = this.toastCtrl.create({
					message: 'Purchased successfully!',
					duration: 5000,
					position: 'middle',
					showCloseButton: true,
					closeButtonText: 'Ok'
				});

				this.businessProvider.refreshBusiness();

				toast.onDidDismiss(() => {
					this.navCtrl.pop();
				});

				toast.present();  
			}
		})
		.catch((err)=>{
			loader.dismiss();

			let toast = this.toastCtrl.create({
				message: 'There was an error: ' + err,
				duration: 3000,
				position: 'bottom'
			});

		  	toast.present();  
		});
	}	
}



// WEBPACK FOOTER //
// ./src/pages/consumer-add-money/consumer-add-money.ts